import { EntityList } from '@avangard/utils/entity';

import { LapEntity } from './lap.entity';

import type { LapRawEntity } from './lap.entity';

class LapEntityList extends EntityList<LapEntity> {
    constructor(items: LapRawEntity[] | null, count?: number | null) {
        super(LapEntity, items, count);
    }
}

export { LapEntityList };
